"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAccordionSummary = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
var OrderPreview_1 = __importDefault(require("./OrderPreview"));
var OrderExpanded_1 = __importDefault(require("./OrderExpanded"));
var material_1 = require("@mui/material");
var styles_1 = require("./styles");
var base_1 = require("../../components/base");
function OrderComponent(_a) {
    var order = _a.order, onExpand = _a.onExpand, expanded = _a.expanded;
    return ((0, jsx_runtime_1.jsx)(StyledContainer, __assign({ onClick: onExpand, className: "twap-order ".concat(expanded ? "twap-order-expanded-wrapper" : "") }, { children: (0, jsx_runtime_1.jsxs)(StyledAccordion, __assign({ expanded: expanded }, { children: [(0, jsx_runtime_1.jsx)(exports.StyledAccordionSummary, { children: (0, jsx_runtime_1.jsx)(OrderPreview_1.default, { order: order, expanded: expanded }) }), (0, jsx_runtime_1.jsxs)(StyledAccordionDetails, __assign({ className: "twap-order-accordion", style: { padding: 0, paddingTop: 10 } }, { children: [(0, jsx_runtime_1.jsx)(OrderSeparator, { className: "twap-order-separator", style: { marginBottom: 10 } }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(OrderExpanded_1.default, { order: order }) })] }))] })) })));
}
var OrderSeparator = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, style = _a.style;
    return (0, jsx_runtime_1.jsx)(styles_1.StyledSeperator, { className: "twap-order-separator ".concat(className), style: style });
};
var StyledAccordionDetails = (0, material_1.styled)(AccordionDetails_1.default)({
    marginTop: 10,
});
exports.default = OrderComponent;
exports.StyledAccordionSummary = (0, material_1.styled)(material_1.AccordionSummary)({
    flexDirection: "column",
    display: "flex",
    width: "100%",
    padding: 0,
});
var StyledContainer = (0, material_1.styled)(base_1.Card)({
    cursor: "pointer",
    "& *": {
        color: "inherit!important",
    },
});
var StyledAccordion = (0, material_1.styled)(Accordion_1.default)({
    width: "100%",
    fontFamily: "inherit",
    padding: 0,
    margin: 0,
    background: "transparent",
    boxShadow: "unset",
    "& .MuiAccordionSummary-content": {
        margin: "0!important",
        width: "100%",
    },
    "& *": {
        color: "inherit",
    },
});
